export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8314.3f17381e.jpg";